import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBulletList: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBulletList"><Path d="M6 4C4.34315 4 3 5.34315 3 7C3 8.65685 4.34315 10 6 10C7.65685 10 9 8.65685 9 7C9 5.34315 7.65685 4 6 4Z" fill="currentColor"/><Path d="M21 6H12V8H21V6Z" fill="currentColor"/><Path d="M21 16H12V18H21V16Z" fill="currentColor"/><Path d="M3 17C3 15.3431 4.34315 14 6 14C7.65685 14 9 15.3431 9 17C9 18.6569 7.65685 20 6 20C4.34315 20 3 18.6569 3 17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBulletList;
